import React, {useContext} from 'react'
import PropTypes from 'prop-types'
import {Box, Flex, Skeleton, SkeletonText, Text} from '@chakra-ui/react'
import Link from '@salesforce/retail-react-app/app/components/link'
import DynamicImage from '@salesforce/retail-react-app/app/components/dynamic-image'
import {mainMenuItemSelected} from '../../integrations/segment/app/page/home'
import {SegmentContext} from '../../integrations/segment/app/contexts'

const MenuCategoryImages = ({
    headerMenuContentCategories = [],
    isLoading = false,
    locale,
    categoryUrlBuilder,
    onClose,
    handleMouseOver,
    handleMouseLeave,
    hoveredIndex
}) => {
    const segmentContext = useContext(SegmentContext)

    if (isLoading || !headerMenuContentCategories.length) {
        return (
            <Box className="menu-category-images">
                <Flex flexDirection="row" gap={4}>
                    {Array.from({length: 4}).map((_, index) => (
                        <Flex key={index} flexDirection="column" alignItems="center" width={'25%'}>
                            <Skeleton
                                borderRadius="8px"
                                marginBottom="4px"
                                height="240px"
                                width="100%"
                                startColor="gray.200"
                                endColor="gray.300"
                            />
                            <SkeletonText noOfLines={1} skeletonHeight="4" />
                        </Flex>
                    ))}
                </Flex>
            </Box>
        )
    }

    return (
        <Box className="menu-category-images">
            <Flex flexDirection="row" gap={4}>
                {headerMenuContentCategories.map((item, index) => (
                    <Flex
                        key={index}
                        flexDirection="column"
                        alignItems="center"
                        as={Link}
                        to={categoryUrlBuilder(item, locale)}
                        onMouseOver={() => handleMouseOver(index)}
                        onMouseLeave={handleMouseLeave}
                        onClick={() => {
                            onClose()
                            mainMenuItemSelected(item, segmentContext)
                        }}
                        width={'25%'}
                    >
                        <DynamicImage
                            data-testid="product-tile-image"
                            src={item?.imageUrl || item?.image}
                            imageProps={{
                                alt: item?.title,
                                loading: 'lazy',
                                style: {
                                    borderRadius: '8px',
                                    marginBottom: '4px',
                                    outline: hoveredIndex === index ? '4px solid #ff640a' : 'none'
                                }
                            }}
                        />
                        <Text
                            fontSize="16px"
                            fontWeight="700"
                            padding="4px"
                            whiteSpace="normal"
                            textAlign="center"
                            color={hoveredIndex === index ? 'linkColor' : 'textColor'}
                            className="link-text-image-title"
                        >
                            {item?.title}
                        </Text>
                    </Flex>
                ))}
            </Flex>
        </Box>
    )
}

MenuCategoryImages.propTypes = {
    headerMenuContentCategories: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string,
            imageUrl: PropTypes.string,
            image: PropTypes.string
        })
    ),
    isLoading: PropTypes.bool,
    locale: PropTypes.string,
    categoryUrlBuilder: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    handleMouseOver: PropTypes.func.isRequired,
    handleMouseLeave: PropTypes.func.isRequired,
    hoveredIndex: PropTypes.number,
    parentCategory: PropTypes.object,
    isSegmentEnabled: PropTypes.bool
}
export default MenuCategoryImages
